import { render, staticRenderFns } from "./AnnotationSimple.vue?vue&type=template&id=777ddf62&scoped=true&"
import script from "./AnnotationSimple.vue?vue&type=script&lang=js&"
export * from "./AnnotationSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777ddf62",
  null
  
)

export default component.exports